import { cn } from '@/lib/utils';

interface IPreviewTabLayoutProps {
  /** Scrollable configuration column (typically SectionCards). */
  children: React.ReactNode;
  /** Right-hand live-preview column. Fills its column height. */
  preview: React.ReactNode;
  /** Pinned footer spanning both columns (typically StickyActionBar). */
  footer?: React.ReactNode;
  /** Width of the preview column (lg+). Hidden below lg. */
  previewWidthClass?: string;
}

/**
 * Shared fill-tab layout for the bot config surfaces that pair a form with a
 * live chatbot preview (Appearance, AI & Persona). Guarantees both tabs share
 * the exact same structure: a scrollable config column on the left, a fixed
 * preview column on the right, and a footer pinned across the bottom.
 */
const PreviewTabLayout: React.FC<IPreviewTabLayoutProps> = ({
  children, preview, footer, previewWidthClass = 'w-[460px] xl:w-[520px]',
}) => (
  <div className="flex-1 min-h-0 flex flex-col">
    <div className="flex-1 min-h-0 flex overflow-hidden">
      <div className="flex-1 min-h-0 overflow-y-auto p-6">{children}</div>
      <div className={cn('hidden shrink-0 border-l border-gray-200 lg:block', previewWidthClass)}>
        {preview}
      </div>
    </div>
    {footer}
  </div>
);

export default PreviewTabLayout;
